import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'פיקסל סטודיו לקחו את החזון שלנו והפכו אותו למציאות מדהימה. התוצאה הסופית עלתה על כל הציפיות שלנו.',
  author: 'דנה שפירא',
  company: 'TechFlow'
}, {
  quote: 'צוות מקצועי, קשוב ויצירתי בטירוף. תהליך העבודה איתם היה חלק ונעים, והאתר החדש שלנו פשוט מושלם.',
  author: 'אמיר גולן',
  company: 'NextGen Solutions'
}, {
  quote: 'ההשקעה בפרטים הקטנים והאנימציות המדויקות עשו את כל ההבדל. ממליצה בחום לכל מי שמחפש איכות ללא פשרות.',
  author: 'מיכל ברק',
  company: 'Creative Minds'
}];
export function Testimonials() {
  return <section className="py-32 relative z-20" data-id="element-155">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-156">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-157">
          {testimonials.map((test, index) => <motion.div key={index} className="p-8 rounded-3xl bg-white/[0.02] border border-white/5 relative" initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} data-id="element-158">
              <div className="flex gap-1 mb-6 text-[#f59e0b]" data-id="element-159">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-160" />)}
              </div>
              <p className="text-lg text-white/80 leading-relaxed mb-8" data-id="element-161">
                "{test.quote}"
              </p>
              <div data-id="element-162">
                <div className="font-bold text-white" data-id="element-163">{test.author}</div>
                <div className="text-white/50 text-sm" data-id="element-164">{test.company}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}